import { render, staticRenderFns } from "./Bookmarks.vue?vue&type=template&id=2e14ffd0"
import script from "./Bookmarks.vue?vue&type=script&lang=js"
export * from "./Bookmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports